import { orgSelectors } from 'ducks/orgs'
import { Icon, Tooltip } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import React from 'react'
import { useSelector } from 'react-redux'

const SurchargingTooltip: React.FC = () => {
  const translate = useTranslate()
  const isStripePsp = useSelector(orgSelectors.getIsCashflowStripePsp)

  const title = isStripePsp
    ? translate(
        'When surcharging is enabled OpenSolar will automatically apply the surcharge amount that you configured in the Stripe Payment Settings page to all card payments'
      )
    : translate(
        "When toggled on, OpenSolar will automatically calculate compliant surcharges to include in customers' card purchases. Note that surcharging will only apply for card purchases."
      )

  return (
    <Tooltip title={title} enterDelay={300}>
      <span>
        <Icon icon="info" size="xSmall" color="#757575" />
      </span>
    </Tooltip>
  )
}

export default SurchargingTooltip
